import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service'; 
@Component({
  selector: 'app-training-placement-committee',
  templateUrl: './training-placement-committee.component.html',
  styleUrls: ['./training-placement-committee.component.scss']
})
export class TrainingPlacementCommitteeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
